export const ASSINATURA_GOVBR_CALLBACK_PATHS = [
  '/workspace/assinatura-govbr',
  '/assinatura-govbr',
];

export const isAssinaturaGovbrCallback = (pathname: string): boolean =>
  ASSINATURA_GOVBR_CALLBACK_PATHS.includes(pathname);
